import React from "react";
import { IconButton } from "@mui/material";

export interface CloseButtonInterface {
  onClick: () => void;
  color?: string;
}

const CloseButton = ({ onClick, color = "black" }: CloseButtonInterface) => {
  return (
    <IconButton onClick={onClick}>
      <i className={`far fa-times font-${color}`}></i>
    </IconButton>
  );
};

export default CloseButton;
